import { createSlice } from '@reduxjs/toolkit';

export const componentsTabSlice = createSlice({
	name: 'selectPage',
	initialState: {
		value: { index: -1, components: false },
	},
	reducers: {
		selectComponents: (state, action) => {
			state.value = action.payload;
		},
	},
});

// Action creators are generated for each case reducer function
export const { selectComponents } = componentsTabSlice.actions;
export const selectedComponents = (state) => state.componentsTab.value.components;
export const selectedIndex = (state) => state.componentsTab.value.index;
export default componentsTabSlice.reducer;
